import { TranslateLoader } from '@ngx-translate/core';
import { reportAssetLoadFailure } from '@shared/helpers/sentry.helper';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// ngx-translate offers no error path of its own: when the language file cannot
// be fetched the failure escapes to Angular's global ErrorHandler and is
// reported as an unhandled crash. A browser that aborted the request mid-load
// is not a crash, so fall back to an empty dictionary — the UI renders its
// translation keys, which is what it did anyway, without the Sentry issue.
export class ResilientTranslateLoader implements TranslateLoader {
  constructor(private readonly _inner: TranslateLoader) {}

  public getTranslation(lang: string): Observable<any> {
    return this._inner.getTranslation(lang).pipe(
      catchError((error: any) => {
        reportAssetLoadFailure(error, (error && error.url) || `i18n/${lang}`);

        return of({});
      })
    );
  }
}
